import { lazy } from "react";
import MapIcon from "@mui/icons-material/Map";

import UploadFileIcon from "@mui/icons-material/UploadFile";

const ManualUploadList = lazy(() => import("../components/manualUploadList"));

const LogsRoute = {
  //   icon: MapIcon,
  //   name: "Routing",
  //   link: "/routing",
  //   path: "routing",
  //   index: 60,
  //   element: "",
  //   superAdminView: false,
  //   children : [
  icon: MapIcon,
  name: "Trip Management",
  link: "/trip-management",
  path: "trip-management",
  index: 8,
  element: "",
  superAdminView: false,
  children: [
    // {
    //     path: "manual-edit",
    //     element: <ManualEdit />,
    //     permission: "Trip Requests-Read",
    //     name: "Manual Edit",
    //     index: 4,
    //     link: "trip-management/manual-edit",
    //     icon: ForkRightIcon,
    //   },
    {
      path: "tripsheet-upload",
      element: <ManualUploadList />,
      permission: "Tripsheet Upload-Read",
      name: "Tripsheet Upload",
      index: 4,
      link: "trip-management/tripsheet-upload",
      icon: UploadFileIcon,
    },
  ],
};
export default LogsRoute;
